module.exports = __webpack_public_path__ + "static/media/banner_2019.3b07327b.jpg";